module.exports = __webpack_public_path__ + "img/2.b0a4294a.jpg";